import { Box, Skeleton } from "@mui/material";

// Streaming-style placeholder for the parts that are actually still in flight. It mirrors the
// loaded layout - chart card on the left, metadata panel on the right, same classes and
// widths - so the page keeps its final shape and nothing jumps when the data arrives.
export default function ChartSkeleton() {
    const border = (theme) => `1px solid ${theme.palette.secondary.dark}`;

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            aria-busy="true"
            aria-label="Loading chart"
            sx={{ flexDirection: { xs: "column", lg: "row" }, gap: "1.2vw" }}
        >
            <Box className="tabs-container" sx={{ border, width: "100%", overflow: "hidden" }}>
                <Skeleton variant="rectangular" height={44} sx={{ transform: "none" }} />
                <Box sx={{ p: "16px" }}>
                    <Skeleton
                        variant="rounded"
                        sx={{ height: { xs: "24vh", md: "32vh" }, transform: "none" }}
                    />
                </Box>
            </Box>

            <Box
                className="metadata"
                sx={{ width: { xs: "auto", lg: "28%" }, border, py: 2, px: 2 }}
            >
                <Skeleton variant="text" width="45%" sx={{ fontSize: "13.6px" }} />
                <Skeleton variant="text" width="90%" />
                <Skeleton variant="text" width="50%" sx={{ fontSize: "13.6px", mt: "17px" }} />
                <Skeleton variant="text" width="95%" />
                <Skeleton variant="text" width="80%" />
                <Skeleton variant="text" width="70%" sx={{ fontSize: "13.6px", mt: "17px" }} />
                <Skeleton variant="text" width="40%" />
            </Box>
        </Box>
    );
}
